/*
 * @Author: Eilvein
 * @DeveloperSite: http://eilvein.cn
 * @Date: 2019-04-23 20:12:37
 * @LastEditors: ROOBO FE
 * @LastEditTime: 2019-11-25 16:32:01
 * @Descripttion:
 */
export const forEach = (arr, fn) => {
    if (!arr.length || !fn) return
    let i = -1
    let len = arr.length
    while (++i < len) {
        let item = arr[i]
        fn(item, i, arr)
    }
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
    let len = Math.min(arr1.length, arr2.length)
    let i = -1
    let res = []
    while (++i < len) {
        const item = arr2[i]
        if (arr1.indexOf(item) > -1) res.push(item)
    }
    return res
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
export const getUnion = (arr1, arr2) => {
    return Array.from(new Set([...arr1, ...arr2]))
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
    return targetarr.some((_) => arr.indexOf(_) > -1)
}

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf(value, validList) {
    for (let i = 0; i < validList.length; i++) {
        if (value === validList[i]) {
            return true
        }
    }
    return false
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = (timeStamp) => {
    const timeStr = String(timeStamp)
    return timeStr.length > 10
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => {
    return timeStamp < currentTime
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = (num) => {
    return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
const getDate = (timeStamp, startType) => {
    const d = new Date(timeStamp * 1000)
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    let resStr = ''
    if (startType === 'year') {
        resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second
    } else {
        resStr = month + '-' + date + ' ' + hours + ':' + minutes
    }
    return resStr
}

/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
export const getRelativeTime = (timeStamp) => {
    // 判断当前传入的时间戳是秒格式还是毫秒
    const IS_MILLISECOND = isMillisecond(timeStamp)
    // 如果是毫秒格式则转为秒格式
    if (IS_MILLISECOND) Math.floor((timeStamp /= 1000))
    // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
    timeStamp = Number(timeStamp)
    // 获取当前时间时间戳
    const currentTime = Math.floor(Date.parse(new Date()) / 1000)
    // 判断传入时间戳是否早于当前时间戳
    const IS_EARLY = isEarly(timeStamp, currentTime)
    // 获取两个时间戳差值
    let diff = currentTime - timeStamp
    // 如果IS_EARLY为false则差值取反
    if (!IS_EARLY) diff = -diff
    let resStr = ''
    const dirStr = IS_EARLY ? '前' : '后'
    // 少于等于59秒
    if (diff <= 59) {
        resStr = diff + '秒' + dirStr
    } else if (diff > 59 && diff <= 3599) {
        // 多于59秒，少于等于59分钟59秒
        resStr = Math.floor(diff / 60) + '分钟' + dirStr
    } else if (diff > 3599 && diff <= 86399) {
        // 多于59分钟59秒，少于等于23小时59分钟59秒
        resStr = Math.floor(diff / 3600) + '小时' + dirStr
    } else if (diff > 86399 && diff <= 2623859) {
        // 多于23小时59分钟59秒，少于等于29天59分钟59秒
        resStr = Math.floor(diff / 86400) + '天' + dirStr
    } else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) {
        // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
        resStr = getDate(timeStamp)
    } else {
        resStr = getDate(timeStamp, 'year')
    }
    return resStr
}

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
    const ua = window.navigator.userAgent
    const isExplorer = (exp) => {
        return ua.indexOf(exp) > -1
    }
    if (isExplorer('MSIE')) return 'IE'
    else if (isExplorer('Firefox')) return 'Firefox'
    else if (isExplorer('Chrome')) return 'Chrome'
    else if (isExplorer('Opera')) return 'Opera'
    else if (isExplorer('Safari')) return 'Safari'
}

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function() {
    if (document.addEventListener) {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false)
            }
        }
    } else {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler)
            }
        }
    }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function() {
    if (document.removeEventListener) {
        return function(element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false)
            }
        }
    } else {
        return function(element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler)
            }
        }
    }
})()

/**
 * 时间格式化函数
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 *
 * @param {Date||number} date Date对象或者时间戳
 * @param {string} fmt 格式化字符串
 *        ("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 *        ("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 * @returns {string} 格式化后的字符串
 */
export const formatDate = (date, fmt) => {
    // 如果是时间戳的话那么转换成Date类型
    if (typeof date === 'number') {
        date = new Date(date)
    } else if (typeof date === 'string') {
        date = new Date(parseInt(date))
    }

    let o = {
        // 月份
        'M+': date.getMonth() + 1,
        // 日
        'd+': date.getDate(),
        // 小时
        'h+': date.getHours(),
        // 分
        'm+': date.getMinutes(),
        // 秒
        's+': date.getSeconds(),
        // 季度
        'q+': Math.floor((date.getMonth() + 3) / 3),
        // 毫秒
        S: date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
    }
    return fmt
}

export const isObjectEmpty = (obj) => {
    if (typeof obj === 'object' && obj !== null && obj !== undefined) {
        return Object.keys(obj).length === 0 && obj.constructor === Object
    }
}

export const isArrayEmpty = (arr) => {
    if (Array.isArray(arr)) {
        return arr.length === 0
    } else {
        return false
    }
}

export const deleteEmptyObject = (test, recurse) => {
    for (var i in test) {
        if (isObjectEmpty(test[i])) {
            delete test[i]
        } else if (recurse && typeof test[i] === 'object') {
            deleteEmptyObject(test[i], recurse)
        }
    }
}

export const deleteEmptyArray = (test, recurse) => {
    for (var i in test) {
        if (isArrayEmpty(test[i])) {
            delete test[i]
        } else if (recurse && Array.isArray(test[i])) {
            deleteEmptyArray(test[i], recurse)
        }
    }
}

export const deleteEmptyString = (test, recurse) => {
    for (var i in test) {
        if (test[i] === '') {
            delete test[i]
        } else if (recurse && typeof test[i] === 'object') {
            deleteEmptyString(test[i], recurse)
        }
    }
}

export const deepObjectCopy = (data) => {
    return JSON.parse(JSON.stringify(data))
}

export const timeToSec = (time) => {
    if (time === '' || typeof time === 'undefined') {
        time = '00:00'
    }

    let s = ''
    let hour = time.split(':')[0]
    let min = time.split(':')[1]
    // let sec = time.split(':')[2];

    // s = Number(hour * 3600) + Number(min * 60) + Number(sec);
    s = Number(hour * 3600) + Number(min * 60)
    return s
}

export const secToTime = (s) => {
    let t
    if (s > -1) {
        let hour = Math.floor(s / 3600)
        let min = Math.floor(s / 60) % 60
        // let sec = s % 60;
        if (hour < 10) {
            t = '0' + hour + ':'
        } else {
            t = hour + ':'
        }
        if (min < 10) {
            t += '0'
        }
        t += min
        // t += min + ':';
        // if (sec < 10) {
        //     t += '0';
        // }
        // t += sec.toFixed(2);
    }
    return t
}

/**
 * randomWord 产生任意长度随机字母数字组合
 * @param randomFlag 是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 * @param min
 * @param max
 * @returns {string}
 */
export const randomWord = (randomFlag, min, max) => {
    let str = ''
    let range = min
    let arr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
    ]
    if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min
    }
    for (var i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1))
        str += arr[pos]
    }
    return str
}

export const getImagesInfo = (file) => {
    let imageExt = '.jpg|.jpeg|.gif|.bmp|.png|'
    let nameSplit = file.name.split('.')
    let format = nameSplit[nameSplit.length - 1].toLowerCase()
    return new Promise((resolve, reject) => {
        let reader = new FileReader()
        let obj = {}
        reader.onload = () => {
            if (reader.result) {
                let imgData = reader.result
                let image = new Image()
                image.onload = () => {
                    obj = {
                        width: image.width,
                        height: image.height,
                        filesize: file.size
                    }
                    if (imageExt.indexOf(`${format}|`) !== -1) {
                        resolve(obj)
                    } else {
                        reject(new Error('[Format Error]:你上传的不是图片文件'))
                    }
                }
                image.src = imgData
            }
        }
        reader.readAsDataURL(file)
    })
}

export const getCharSizeByCanvas = (char, style = {}) => {
    let canvas = document.createElement('canvas')
    canvas.style.positon = 'ablsolute'
    let ctx = canvas.getContext('2d')
    let { fontSize = 14, fontFamily = 'Arial' } = style
    document.body.appendChild(canvas)
    ctx.font = `${fontSize}px${fontFamily}`
    document.body.removeChild(canvas)
    let text = ctx.measureText(char)
    ctx.fillText(char, 50, 50)
    let result = {
        height: fontSize,
        width: text.width
    }
    return result
}

/**
 * @name: getCharSize
 * @description: 获取字体宽度
 * @param {type}
 * @return:
 */
export const getCharSize = (char, style = {}) => {
    let span = document.createElement('span')
    span.style.positon = 'ablsolute'
    let { fontSize = 14, fontFamily = 'Arial' } = style
    let scale = fontSize / 20
    span.style.fontSize = '20px'
    span.style.fontFamily = fontFamily
    span.style.lineHeight = '0'
    span.style.transform = `scale(${scale})`
    span.style.display = 'inline-block'
    span.innerHTML = char
    document.body.appendChild(span)
    let rect = span.getBoundingClientRect()
    let width = rect.width
    document.body.removeChild(span)
    return {
        width,
        height: fontSize
    }
}
/**
 * @name: classifiedArray
 * @description:
 * @param {type}
 * @return:
 */
export const classifiedArray = (data, name) => {
    if (!name && !Array.isArray(data) && typeof name !== 'string') {
        return
    }
    let obj = {}
    let Arr = []
    data.forEach((item) => {
        console.log(item)
        let key = Object.keys(item)
        key.forEach((el) => {
            console.log(el)
            // 初始化，赋值初始值
            !obj[item[name]] && (obj[item[name]] = {})
            // 根据name往对象下的子对象赋值
            obj[item[name]][el] = item[el]
        })
    })
    Object.values(obj).forEach((item) => {
        Arr.push(item)
    })
    return Arr
}
/**
 * @name:sortBy
 * @description:
 * @param {type}
 * @return:
 */
export const sortBy = (props) => {
    return (a, b) => {
        return a[props] - b[props]
    }
}

/**
 * @name: randomRgbaColor
 * @description: 随机 Rgba 颜色
 * @param {type}
 * @return:
 */
export const randomRgbaColor = (min, max) => {
    let r = min + (Math.round(Math.random() * 1000) % (max - min))
    let g = min + (Math.round(Math.random() * 1000) % (max - min))
    let b = min + (Math.round(Math.random() * 1000) % (max - min))
    return `rgb(${r},${g},${b})`
}

/**
 * @name: dataURLtoFile
 * @description: 将base64转换成file对象
 * @param {type}
 * @return:
 */
export const dataURLtoFile = (dataurl, filename = 'file') => {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `${filename}.${suffix}`, { type: mime })
}

/**
 * @name: convertImageToCanvas
 * @description: Canvas生成图
 * @param {type}
 * @return:
 */
export const convertImageToCanvas = (w, h, text) => {
    let canvas = document.createElement('canvas')
    canvas.width = w
    canvas.height = h
    let context = canvas.getContext('2d') // 获取对应的2D对象(画笔)
    context.fillStyle = this.randomRgbaColor(210, 256) // 设置填充的背景颜色
    context.fillRect(0, 0, w, h) // 绘制 w*h 像素的已填充矩形：
    context.fillStyle = '#fff'
    context.textAlign = 'center'
    context.font = "bold 18px'字体','字体','宋体'" // 设置字体
    context.textBaseline = 'hanging' // 在绘制文本时使用的当前文本基线
    context.fillText(text, w / 2, h / 2 - 9) // 设置文本内容
    return canvas.toDataURL('image/png')
}

/**
 * @name: downLoad
 * @description: 动态生成下载标签
 * @param {type}
 * @return:
 */
export const downLoad = (url) => {
    let oA = document.createElement('a')
    oA.download = ''
    oA.href = url
    document.body.appendChild(oA)
    oA.click()
    oA.remove()
}



// WEBPACK FOOTER //
// ./src/utils/tools.js